import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import PageTransition from '../components/PageTransition';
import { LanguageContext } from '../context/LanguageContext';

export default function Articles() {
  const { language } = useContext(LanguageContext);

  const texts = {
    EN: {
      title: "Texts & Publications",
      back: "back"
    },
    PT: {
      title: "Textos & Publicações",
      back: "retornar"
    }
  };

  const t = texts[language];

  return (
    <PageTransition>
      <div className="page-container">
        <Link to="/" className="back-button">&lt; {t.back}</Link>
        <h1>{t.title}</h1>
        {/* Add your articles content here */}
      </div>
    </PageTransition>
  );
}